// The site's real launch switch.
//
// There used to be a LAUNCH_DATE here and everything keyed off the calendar.
// It never opened anything — the gate below and the "/" route in
// web/vercel.json are both manual — but it did close things: PasswordGate
// ANDed !isPostLaunch into the organizer bypass, so at midnight on launch day
// every onboarded organizer lost access whether or not the site had actually
// been unlocked. The date could only ever fail.
//
// Flip REACT_APP_SITE_LOCKED to false in Vercel and the site opens: the gate
// passes everyone through and the organizers' pre-launch banner stops
// rendering. Both read it from here so they cannot disagree.
export const SITE_LOCKED = process.env.REACT_APP_SITE_LOCKED === 'true';
export const SITE_PASSWORD = process.env.REACT_APP_SITE_PASSWORD || '';
